import React from 'react';
import { motion } from 'framer-motion';

const clients = [
  { name: 'ORIGINAL MARINES', country: 'Italy' },
  { name: 'MANGO', country: 'Spain' },
  { name: 'NEXT', country: 'United Kingdom' },
  { name: 'CHICCO', country: 'Italy' },
  { name: 'PRENATAL', country: 'Italy' },
  { name: 'BABYSHOP', country: 'UAE' },
  { name: 'OVS', country: 'Italy' },
  { name: 'MONOPRIX', country: 'France' },
  { name: 'MAYORAL', country: 'Spain' },
  { name: 'MAISON 123', country: 'France' },
];

const ClientMarquee = () => {
  return (
    <section 
      data-testid="client-marquee-section"
      className="py-16 md:py-20 bg-slate-900 overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Section Label */}
        <p className="text-center font-sans text-xs font-medium tracking-[0.3em] uppercase text-white/40 mb-10">
          Trusted by Leading Global Brands
        </p>

        {/* Marquee Container */}
        <div className="relative">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-900 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-900 to-transparent z-10" />

          {/* Marquee Track */}
          <div className="flex animate-marquee">
            {/* First set */}
            {clients.map((client, index) => (
              <div
                key={`first-${index}`}
                className="flex items-center px-8 md:px-12 whitespace-nowrap group"
              >
                <div className="flex flex-col items-center">
                  <span className="font-serif text-2xl md:text-3xl font-medium text-white tracking-wide group-hover:text-rose-400 transition-colors duration-300">
                    {client.name}
                  </span>
                  <span className="font-sans text-[10px] text-white/40 uppercase tracking-[0.2em] mt-1">
                    {client.country}
                  </span>
                </div>
                <span className="mx-8 md:mx-12 text-white/20">•</span>
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {clients.map((client, index) => (
              <div
                key={`second-${index}`}
                className="flex items-center px-8 md:px-12 whitespace-nowrap group"
              >
                <div className="flex flex-col items-center">
                  <span className="font-serif text-2xl md:text-3xl font-medium text-white tracking-wide group-hover:text-rose-400 transition-colors duration-300">
                    {client.name}
                  </span>
                  <span className="font-sans text-[10px] text-white/40 uppercase tracking-[0.2em] mt-1">
                    {client.country}
                  </span>
                </div>
                <span className="mx-8 md:mx-12 text-white/20">•</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default ClientMarquee;
